module.exports = __webpack_public_path__ + "media/images/design/images/vol_search/btn_vol01-68c37fc0cbad00b8c77b7d417d3c108d.png";